import {
  FaChartBar,
  FaCheckCircle,
  FaChalkboardTeacher,
  FaClipboardCheck,
  FaFileExcel,
  FaMobileAlt,
  FaSchool,
  FaStopwatch,
  FaUsers,
} from "react-icons/fa";

export const JUDO_PRESENCE_PRO = {
  name: "Judo Présence Pro",
  logo: "/images/judopresencepro/logo_judopresencepro.png",

  externalUrl: "https://www.judo-presence-pro.com/",

  donationUrl: "https://buy.stripe.com/fZe8xlaqLgYkdj2fYZ",

  eyebrow: "Application de suivi des présences",

  title: "L’appel devient simple.",
  highlightedTitle: "Le suivi devient utile.",

  description:
    "Judo Présence Pro permet aux dirigeants et enseignants de gérer leurs groupes, pointer les présences et suivre la fréquentation du club depuis tous leurs appareils.",

  heroImages: [
    {
      src: "/images/diaporama/007.png",
      alt: "Appel des judokas par groupe",
    },
    {
      src: "/images/diaporama/008.png",
      alt: "Tableau de bord des présences",
    },
  ],
};

export const JUDO_PRESENCE_HIGHLIGHTS = [
  {
    icon: FaStopwatch,
    title: "Un appel rapide",
    text: "Quelques secondes suffisent pour enregistrer les présents et les absents.",
  },
  {
    icon: FaChalkboardTeacher,
    title: "Un accès par enseignant",
    text: "Chaque enseignant accède uniquement aux groupes qui lui sont attribués.",
  },
  {
    icon: FaChartBar,
    title: "Des statistiques utiles",
    text: "Suivez la fréquentation par dojo, groupe, adhérent et période.",
  },
];

export const JUDO_PRESENCE_FEATURES = [
  {
    id: "attendance",
    eyebrow: "Pendant les cours",
    title: "Pointer les présences en quelques secondes",
    description:
      "L’enseignant sélectionne son dojo et son groupe, puis indique rapidement les présents et les absents.",
    image: "/images/diaporama/007.png",
    imageAlt: "Page de pointage des présences",
    icon: FaClipboardCheck,
    points: [
      "Affichage des adhérents du groupe",
      "Présent, absent ou non renseigné",
      "Utilisable sur smartphone et tablette",
    ],
  },
  {
    id: "organization",
    eyebrow: "Organisation du club",
    title: "Retrouver tous les dojos et groupes",
    description:
      "Les dirigeants configurent la structure du club et attribuent chaque groupe aux enseignants concernés.",
    image: "/images/diaporama/004.png",
    imageAlt: "Gestion des dojos et groupes",
    icon: FaSchool,
    points: [
      "Gestion de plusieurs dojos",
      "Création des groupes et horaires",
      "Attribution des enseignants",
    ],
  },
  {
    id: "members",
    eyebrow: "Gestion des adhérents",
    title: "Importer et organiser les judokas",
    description:
      "Les adhérents peuvent être ajoutés individuellement ou importés rapidement depuis un fichier existant.",
    image: "/images/diaporama/005.png",
    imageAlt: "Importation des adhérents",
    icon: FaUsers,
    points: [
      "Importation depuis un fichier Excel",
      "Inscription individuelle",
      "Affectation dans les groupes",
    ],
  },
  {
    id: "statistics",
    eyebrow: "Pilotage",
    title: "Comprendre la fréquentation du club",
    description:
      "Les tableaux de bord permettent d’identifier les groupes actifs et les évolutions de fréquentation.",
    image: "/images/diaporama/009.png",
    imageAlt: "Statistiques des présences",
    icon: FaChartBar,
    points: [
      "Statistiques par groupe et dojo",
      "Suivi individuel des adhérents",
      "Export et analyse des données",
    ],
  },
];

export const JUDO_PRESENCE_PLANS = [
  {
    id: "demo",
    name: "Mode Démo",
    priceText: "Gratuit",
    suffix: "",
    eyebrow: "Découverte",
    capacity: "1 dojo · 2 groupes · moins de 50 adhérents",
    description:
      "La formule idéale pour démarrer avec un petit club.",
    features: [
      "Découverte des principales pages",
      "Aucun engagement",
      "Accès immédiat",
    ],
    cta: "Tester la démonstration",
  },
  {
    id: "presence",
    name: "Présence",
    priceText: "10 €",
    suffix: "/an",
    eyebrow: "Petit club",
    capacity: "1 dojo · - de 100 adhérents",
    description:
      "Une formule simple pour un club utilisant un seul dojo et souhaitant suivre ses présences.",
    features: [
      "Gestion du club",
      "Gestion d’un dojo",
      "Création des groupes",
      "Gestion des enseignants",
      "Jusqu’à 100 adhérents",
      "Présences et absences",
      "Tableau de bord",
      "Statistiques",
    ],
    cta: "Choisir Présence",
  },
  {
    id: "presence-pro",
    name: "Présence Pro",
    priceText: "20 €",
    suffix: "/an",
    eyebrow: "Formule recommandée",
    capacity: "Jusqu’à 3 dojos · 100 à 200 adhérents",
    description:
      "La formule adaptée aux clubs disposant de plusieurs lieux de pratique et de plusieurs groupes.",
    features: [
      "Toutes les fonctions de Présence",
      "Gestion de 3 dojos maximum",
      "Jusqu’à 200 adhérents",
      "Plusieurs enseignants",
      "Suivi par dojo et groupe",
      "Statistiques détaillées",
      "Importation des adhérents",
      "Exports de données",
    ],
    cta: "Choisir Présence Pro",
    recommended: true,
  },
  {
    id: "presence-ultim",
    name: "Présence Ultim",
    priceText: "30 €",
    suffix: "/an",
    eyebrow: "Club important",
    capacity: "Plus de 3 dojos · plus de 200 adhérents",
    description:
      "Une formule complète pour les clubs qui disposent de plusieurs sites et d’un effectif important.",
    features: [
      "Toutes les fonctions de Présence Pro",
      "Plus de 3 dojos",
      "Plus de 200 adhérents",
      "Gestion d’un grand nombre de groupes",
      "Accès dirigeants et enseignants",
      "Statistiques complètes",
      "Importations et exports",
      "Accompagnement à la prise en main",
    ],
    cta: "Choisir Présence Ultim",
  },
];

export const JUDO_PRESENCE_GALLERY = [
  {
    src: "https://www.judo-presence-pro.com/images/diaporama/001.png",
    alt: "Menu de Judo Présence Pro",
    category: "Navigation",
    title: "Une navigation simple",
    caption:
      "Les différentes fonctions de l’application restent accessibles depuis un menu clair.",
  },
  {
    src: "https://www.judo-presence-pro.com/images/diaporama/002.png",
    alt: "Formules Judo Présence Pro",
    category: "Formules",
    title: "Des offres adaptées à la taille du club",
    caption:
      "Le club sélectionne uniquement la capacité correspondant à son organisation.",
  },
  {
    src: "https://www.judo-presence-pro.com/images/diaporama/003.png",
    alt: "Création du club",
    category: "Configuration",
    title: "Création du club",
    caption:
      "Le dirigeant renseigne les informations principales de sa structure.",
  },
  {
    src: "https://www.judo-presence-pro.com/images/diaporama/004.png",
    alt: "Création des dojos et groupes",
    category: "Organisation",
    title: "Dojos et groupes",
    caption:
      "Les lieux de pratique, groupes et horaires sont organisés depuis l’administration.",
  },
  {
    src: "https://www.judo-presence-pro.com/images/diaporama/005.png",
    alt: "Ajout des judokas",
    category: "Adhérents",
    title: "Importation des judokas",
    caption:
      "Les adhérents peuvent être importés depuis un fichier Excel ou ajoutés individuellement.",
  },
  {
    src: "https://www.judo-presence-pro.com/images/diaporama/006.png",
    alt: "Création des enseignants",
    category: "Enseignants",
    title: "Inviter les enseignants",
    caption:
      "Chaque enseignant reçoit un accès aux groupes dont il a la responsabilité.",
  },
  {
    src: "https://www.judo-presence-pro.com/images/diaporama/007.png",
    alt: "Page de présence",
    category: "Présences",
    title: "Faire l’appel",
    caption:
      "L’enseignant visualise uniquement les adhérents de son groupe et enregistre leur présence.",
  },
  {
    src: "https://www.judo-presence-pro.com/images/diaporama/008.png",
    alt: "Tableau de bord des présences",
    category: "Tableau de bord",
    title: "Une vision synthétique",
    caption:
      "Le tableau de bord présente les principaux indicateurs de fréquentation du club.",
  },
  {
    src: "https://www.judo-presence-pro.com/images/diaporama/009.png",
    alt: "Statistiques des présences",
    category: "Statistiques",
    title: "Analyser la fréquentation",
    caption:
      "Les statistiques peuvent être consultées par dojo, groupe, adhérent et période.",
  },
];

export const JUDO_PRESENCE_TECHNICAL_POINTS = [
  {
    icon: FaMobileAlt,
    label: "Smartphone, tablette et ordinateur",
  },
  {
    icon: FaFileExcel,
    label: "Importation et export des données",
  },
  {
    icon: FaCheckCircle,
    label: "Accès sécurisé par utilisateur",
  },
];